import { useSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import { addItemsToCart, removeItemsFromCart } from '../../actions/cartAction';
import { getDeliveryDate, getDiscount } from '../../utils/functions';
import { saveForLater } from '../../actions/saveForLaterAction';
import { Link } from 'react-router-dom';
import { Box, Button, Card, CardContent, CardMedia, IconButton, TextField, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import { useTheme } from '@mui/material/styles';

const CartItem = ({ product, name, brand, price, mrp, image, stock, quantity, size, inCart }) => {

    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const theme = useTheme();

    const increaseQuantity = (id, quantity, stock) => {
        const newQty = quantity + 1;
        if (quantity >= stock) {
            enqueueSnackbar("Maximum Order Quantity", { variant: "warning" });
            return;
        };
        dispatch(addItemsToCart(id, newQty, size));
    }

    const decreaseQuantity = (id, quantity) => {
        const newQty = quantity - 1;
        if (quantity <= 1) return;
        dispatch(addItemsToCart(id, newQty, size));
    }
    
    const removeCartItem = (id, size) => {
        dispatch(removeItemsFromCart(id, size));
        enqueueSnackbar("Product Removed From Cart", { variant: "success" });
    }

    const saveForLaterHandler = (id) => {
        dispatch(saveForLater(id));
        removeCartItem(id, size);
        enqueueSnackbar("Saved For Later", { variant: "success" });
    }

    return (
        <Card sx={{ display: 'flex', mb: 2, bgcolor: 'background.default' }}>
            <CardMedia
                component="img"
                sx={{ width: 151, objectFit: 'contain', p: 2 }}
                image={image}
                alt={name}
            />
            <Box sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <CardContent>
                    <Link to={`/product/${product}`} style={{ textDecoration: 'none', color: 'inherit' }}>
                        <Typography component="div" variant="h6" noWrap={false}>
                            {name}
                        </Typography>
                    </Link>
                    <Typography variant="subtitle2" color="text.secondary" component="div">
                        Brand: {brand}
                    </Typography>
                    {size && (
                        <Typography variant="subtitle2" color="text.secondary" component="div">
                            Size: {size}
                        </Typography>
                    )}
                    <Box sx={{ display: 'flex', alignItems: 'baseline', my: 1 }}>
                        <Typography variant="h5">₹{(price * quantity).toLocaleString()}</Typography>
                        <Typography variant="subtitle1" color="text.secondary" sx={{ textDecoration: 'line-through', mx: 1 }}>
                            ₹{(mrp * quantity).toLocaleString()}
                        </Typography>
                        <Typography variant="subtitle1" sx={{ color: theme.palette.success.main }}>
                            {getDiscount(price, mrp)}% off
                        </Typography>
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                        Delivery by {getDeliveryDate()} | <span style={{ color: theme.palette.success.main }}>Free</span>
                    </Typography>
                </CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', pl: 1, pb: 1 }}>
                    <IconButton onClick={() => decreaseQuantity(product, quantity)}>
                        <RemoveIcon />
                    </IconButton>
                    <TextField 
                        value={quantity} 
                        disabled 
                        sx={{ width: '50px', mx: 1, '& .MuiInputBase-input.Mui-disabled': { textAlign: 'center' } }}
                    />
                    <IconButton onClick={() => increaseQuantity(product, quantity, stock)}>
                        <AddIcon />
                    </IconButton>
                    {inCart && (
                        <>
                            <Button onClick={() => saveForLaterHandler(product)} sx={{ ml: 2 }}>SAVE FOR LATER</Button>
                            <Button onClick={() => removeCartItem(product, size)} sx={{ color: theme.palette.error.main }}>REMOVE</Button>
                        </>
                    )}
                </Box>
            </Box>
        </Card>
    );

};

export default CartItem;